/*
 * @Author: haoliang.yan
 * @Date: 2017-03-09 17:41:20
 * @Last modified by:   yangnan.yang
 * @Last modified time: 2017-06-06T20:41:55+08:00
 */
/* eslint-disable*/
const DEFAULT_TYPE = 'VC_UNKNOWN_ACTION';
const enc = encodeURIComponent;
const dec = decodeURIComponent;
const UDF = 'undefined';
const NIL = null;
import { request } from './request';
const storage = require('./qstorage');
import getMpEnv from './getMpEnv';
import {smartJump} from '@qnpm/vc_jump';
const env = getMpEnv()
/**
 * iOS 是否展示头部20px边距
 * 由于hysdk的qunar sniff 注入是异步的，这里直接判断UA
 */
const UA = navigator.userAgent.toLowerCase();
const isQunarApp = UA.match('(^|\\s)(qunar[^\\/]+)\\/([\\d\\.]+)');
const isQunargonglve = UA.match(/(^|\s)(qunartravel[^\/]+)\/([\d\.]+)/);
const isPro = UA.match(/(qunar(a|i)phonepro)/); // pro
const isDeals = UA.match(/(qunar(a|i)phonedeals)/); //  特卖
const iosStatusBar = (isQunarApp && hysdk.sniff.ios && hysdk.sniff.osVersionN >= 7) || false;

const appLink = {
    default: 'itms-apps://itunes.apple.com/cn/app/id395096736',
    pro: 'itms-apps://itunes.apple.com/cn/app/id655516874',
    deals: 'itms-apps://itunes.apple.com/cn/app/id1149235813'
};
const createAction = (type = DEFAULT_TYPE, payload = null) => {
    return {
        type,
        payload
    };
};

const jsonChecker = json => {
    if (json && json.ret) {
        return Promise.resolve(json.data);
    } else {
        return Promise.reject();
    }
};

const buildListURL = (dep, query, params = {}) => {
    const pair = [];

    params.dep = dep;
    params.query = query;

    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            pair.push(`${enc(key)}=${enc(params[key])}`);
        }
    }
    const raw = pair.join('&');

    if (hysdk.sniff.qunar) {
        return `${hysdk.sniff.scheme}://vacation/list?${raw}`;
    } else {
        return `${location.origin}/p/list?${raw}`;
    }
};

const getCookie = cookieName => {
    let strCookie = document.cookie,
        arrCookie = strCookie.split('; ');

    for (let i = 0; i < arrCookie.length; i++) {
        let arr = arrCookie[i].split('=');

        if (cookieName === arr[0]) {
            return decodeURI(arr[1]);
        }
    }
    return '';
};

const getHashParams = () => {
    let search = location.hash;
    if (/\#.+/gi.test(search)) {
        try {
            search = decodeURIComponent(search.slice(1));
            let result = search.match(/[^&]+/gi),
                i,
                len,
                arrTemp,
                ret = {};
            if (result) {
                for (i = 0, len = result.length; i < len; i++) {
                    arrTemp = result[i].split('=');
                    if (arrTemp && arrTemp[0] && arrTemp[1]) {
                        ret[arrTemp[0]] = arrTemp[1];
                    }
                }

                if (ret) {
                    return ret;
                }
            }
        } catch (e) { }
    }

    return false;
};
const getQueryString = name => {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'),
        r = window.location.search.substr(1).match(reg);

    if (r !== null) {
        return dec(dec(r[2]));
    }
    return null;
};

const getLink = path => {
    let link = document.createElement('a');

    link.href = path;
    return link;
};

const getQueryParams = uri => {
    let search = uri ? getLink(uri).search : location.search;
    let ret = {};

    if (/\?.+/gi.test(search)) {
        try {
            search = search.slice(1);
            search.split('&').forEach(function (param) {
                let parts = param.replace(/\+/g, ' ').split('=');
                let key = parts.shift();
                let val = parts.length > 0 ? parts.join('=') : UDF;

                val && (ret[dec(dec(key))] = dec(dec(val)));
            });
        } catch (e) { }
    }
    return ret;
};

/**
 * 用于处理相对路径、绝对路径等URL
 * @param {String} url
 */
const getFullUrl = url => {
    const a = document.createElement('a');
    a.href = url;

    return a.href;
};
const isNotEmpty = data => {
    if (Object.prototype.toString.call(data) === '[object Array]') {
        if (data.length > 0) {
            return true;
        } else {
            return false;
        }
    } else if (Object.prototype.toString.call(data) === '[object Object]') {
        for (let name in data) {
            if (data.hasOwnProperty(name)) {
                return true;
            }
        }
        return false;
    } else if (Object.prototype.toString.call(data) === '[object String]') {
        if (data.length > 0) {
            return true;
        }
        return false;
    } else {
        return !!data;
    }
};

const getOnLineStatus = () => {
    return new Promise(resolve => {
        let result = {
            isWifi: false,
            onLine: navigator.onLine
        };
        if (hysdk.sniff.pc) {
            result.isWifi = true;
            resolve(result);
        } else if (isQunarApp) {
            hysdk.ready(function () {
                hysdk.getNetworkType({
                    success: function (res) {
                        // 返回网络类型2g，3g，2g/3g，4g，wifi，unknown
                        let networkType = res.networkType;
                        if (networkType === 'wifi') {
                            result.isWifi = true;
                        }
                        resolve(result);
                    },
                    fail: function () {
                        resolve(result);
                    }
                });
            });
        } else if (
            navigator.connection &&
            navigator.connection.type &&
            navigator.connection.type === 'wifi'
        ) {
            result.isWifi = true;
            resolve(result);
        } else {
            resolve(result);
        }
    });
};

const updateQueryString = function (url, key, value) {
    let parts = url.split('#'),
        uri = parts.shift(),
        hash = '',
        re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i'),
        separator = uri.indexOf('?') !== -1 ? '&' : '?';

    if (parts.length) {
        hash = '#' + parts.join('#');
    }

    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2') + hash;
    } else {
        return uri + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value) + hash;
    }
};

const isNotNil = function (value) {
    return !(typeof value === UDF || value === UDF || value === NIL);
};

const isOldversion = function (andv, iosv) {
    // 如果不是客户端或是攻略，则不判断版本
    if (!isQunarApp || isQunargonglve) {
        return {
            flag: false
        };
    }
    const match = UA.match(/(^|\s)(qunar(?!travel)[^\/]+)\/([\d\.]+)/);
    if (!match || !match[3]) {
        return {
            flag: false
        };
    }
    const appVersion = match[3];
    const minVersion = hysdk.sniff.android ? andv : iosv;
    return {
        flag: parseFloat(appVersion) < parseFloat(minVersion),
        version: appVersion
    };
};

const getAppLink = function () {
    if (hysdk.sniff.android || isQunargonglve) {
        return null;
    }
    if (isPro) {
        return appLink.pro;
    } else if (isDeals) {
        return appLink.deals;
    } else {
        return appLink.default;
    }
};

const getValue = (obj, field = '-', defaults) => {
    if (field === '-') {
        return obj;
    }
    const fields = field.split('.');
    const udf = void 0;
    let ret = obj;
    fields.every(key => {
        if (typeof ret !== 'object' || ret === null || !ret.hasOwnProperty(key)) {
            ret = udf;
            return false;
        } else {
            ret = ret[key];
            return true;
        }
    });

    return ret !== udf ? ret : defaults;
};

const prettyNumber = num => {
    try {
        if (num === null || num === void 0) {
            return '';
        }
        const n = parseInt(num, 10);
        // 超过1万，显示1.*万
        if (n > 1e4) {
            return `${(n / 1e4).toFixed(1)}万`;
        } else {
            return n;
        }
    } catch (e) {
        return num;
    }
};
// 获取用户常住地
const ONEHOUR = 1 * 3600 * 1000;
const getUserResident = () => {
    // err 1 非app 2 无城市返回 3 没有获取到uid
    return new Promise((resolve, reject) => {
        const userResident = storage('userResident-v1');
        if (!isQunarApp) {
            reject(1);
            return;
        }
        if (userResident === null) {
            if (!hysdk.isReady) {
                hysdk.config({
                    debug: false,
                    wechatScriptUrl: 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js'
                });
            }
            hysdk.ready(() => {
                hysdk.getDeviceInfo({
                    success: function (res) {
                        if (res.uid) {
                            request(`/user_resident.json?uid=${res.uid}`)
                                .then(resp => resp.json())
                                .then(resp => {
                                    if (resp.ret && resp.data && resp.data.city) {
                                        const city = resp.data.city;
                                        storage('userResident-v1', city, ONEHOUR);
                                        resolve(city);
                                    } else {
                                        reject(2);
                                    }
                                });
                        } else {
                            reject(3);
                        }
                    }
                });
            });
        } else {
            resolve(userResident);
        }
    });
};

function throttle (func, wait, options) {
    let timeout, context, args;
    let previous = 0;
    if (!options) options = {};

    let later = function () {
        previous = options.leading === false ? 0 : new Date().getTime();
        timeout = null;
        func.apply(context, args);
        if (!timeout) context = args = null;
    };

    let throttled = function () {
        let now = new Date().getTime();
        if (!previous && options.leading === false) previous = now;
        let remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
    };
    return throttled;
}


function debounce (func, wait, immediate) {
    let timeout, result;

    let debounced = function () {
        let context = this;
        let args = arguments;

        if (timeout) clearTimeout(timeout);
        if (immediate) {
            // 如果已经执行过，不再执行
            let callNow = !timeout;
            timeout = setTimeout(function () {
                timeout = null;
            }, wait);
            if (callNow) result = func.apply(context, args);
        } else {
            timeout = setTimeout(function () {
                func.apply(context, args);
            }, wait);
        }
        return result;
    };

    debounced.cancel = function () {
        clearTimeout(timeout);
        timeout = null;
    };

    return debounced;
}

/*  计算两个坐标间的距离 */
function toRad (d) {
    return (d * Math.PI) / 180;
}

function getDistance (point1, point2) {
    let dis = 0;
    let lat1 = point1.split(',')[1],
        lng1 = point1.split(',')[0],
        lat2 = point2.split(',')[1],
        lng2 = point2.split(',')[0];
    if (!lat1 || !lng1 || !lat2 || !lng2) return;
    let radLat1 = toRad(lat1);
    let radLat2 = toRad(lat2);
    let deltaLat = radLat1 - radLat2;
    let deltaLng = toRad(lng1) - toRad(lng2);
    dis =
        2 *
        Math.asin(
            Math.sqrt(
                Math.pow(Math.sin(deltaLat / 2), 2) +
                Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)
            )
        );
    return ((dis * 6378137) / 1000).toFixed(1);
}

function judgePartVisible (ele) {
    if (!ele) return;
    const rect = ele.getBoundingClientRect();
    const height = ele.clientHeight;
    const winH = window.innerHeight || document.documentElement.clientHeight;
    return (
        rect.top >= -height && rect.top <= winH
    );
}

let loginIns;
const getLoginIns = (loginConfig = {}, Singleton = true) => {
    if (Singleton && loginIns) {
        return loginIns;
    }
    loginIns = window.ucAPI && ucAPI.loginDialog && ucAPI.loginDialog.createInstance({
        instanceConfig: {
            source: 'vacation'
        },
        instanceFunc: {
            wxAuthedReceived: () => {
                window.loginSuccessCallback && window.loginSuccessCallback();
            }
        },
        success: function () {
            window.loginSuccessCallback && window.loginSuccessCallback();
        },
        title: loginConfig.title || '短信验证码登录',
        fail: () => { },
        ...loginConfig
    }) || {};
    return loginIns;
};
let hasLoadSDK = false;
function loadSDK(sdkUrl) {
    if (!sdkUrl || hasLoadSDK) {
        return Promise.resolve();
    }
    return new Promise(resolve => {
        const script = document.createElement('script');
        script.src = sdkUrl;
        script.onload = function() {
            hasLoadSDK = true;
            resolve();
        };
        document.querySelector('head').appendChild(script);
    });
}

// 默认单例模式，只创建一个 loginInstance
function checkLogin(loginConfig, Singleton = true, showDialog = true, extraPrams = {}) {
    return new Promise(resolve => {
        hysdk.ready(() => {
            hysdk.checkLogin({
                success: function(res) {
                    // 未登录，且需要登陆
                    if (!res.login && showDialog) {
                        // 微信小程序
                        if (env && env.mpName && env.mpName === 'wx') {
                            const successPath = `/pages/vacation/webview/index`;
                            const successUrl = location.href;
                            const url = `/pages/alonePlatform/login/index?source=vacation&successPath=${encodeURIComponent(successPath)}&successUrl=${encodeURIComponent(successUrl)}`;
                            window.wx.miniProgram.navigateTo({
                                url: url
                            });
                        } else if (env && env.mpName && env.mpName === 'tt') {
                            const successPath = `/pages/vacation/webview/index`;
                            const successUrl = location.href;
                            const url = `/pages/platform/login/index?source=vacation&successPath=${encodeURIComponent(successPath)}&successUrl=${encodeURIComponent(successUrl)}`;
                            loadSDK(env.sdk).then(() => {
                                window.tt.miniProgram.navigateTo({
                                    url: url
                                });
                            });
                        } else {
                            const loginInstance = getLoginIns(loginConfig, Singleton);
                            loginInstance.instanceFunc && loginInstance.instanceFunc.showDialog();
                        }
                    }
                    resolve(res.login);
                },
                fail: () => {
                    reject();
                }
            });
        })
    });
};



function login(params = {}) {
    const {
        loginConfig,
        Singleton = true,
        useUcApi = true,
        needLogin = true,
        weixinAuth = true
    } = params;
    return new Promise(resolve => {
        hysdk.ready(() => {
            hysdk.checkLogin({
                success: function(res) {
                    // 未登录，且需要登陆
                    if (!res.login && needLogin) {
                        // 微信小程序
                        if(hysdk.sniff.qunar) {
                            hysdk.login({
                                shouldOpenLogin: true,
                                extData: 'source=vacation',
                                instanceConfig: {
                                    weixinAuth
                                },
                                success: () => {
                                    resolve(true)
                                },
                                fail: () => {
                                    resolve(false);
                                }
                            });
                        } else if (env && env.mpName && env.mpName === 'wx') {
                            const successPath = `/pages/vacation/webview/index`;
                            const successUrl = location.href;
                            const url = `/pages/alonePlatform/login/index?source=vacation&successPath=${encodeURIComponent(successPath)}&successUrl=${encodeURIComponent(successUrl)}`;
                            window.wx.miniProgram.navigateTo({
                                url: url
                            });
                        } else if (env && env.mpName && env.mpName === 'tt') {
                            const successPath = `/pages/vacation/webview/index`;
                            const successUrl = location.href;
                            const url = `/pages/platform/login/index?source=vacation&successPath=${encodeURIComponent(successPath)}&successUrl=${encodeURIComponent(successUrl)}`;
                            loadSDK(env.sdk).then(() => {
                                window.tt.miniProgram.navigateTo({
                                    url: url
                                });
                            });
                        } else {
                            if(useUcApi) {
                                const loginInstance = getLoginIns(loginConfig, Singleton);
                                loginInstance.instanceFunc && loginInstance.instanceFunc.showDialog();
                            }else {
                                location.href = `https://user.qunar.com/mobile/login.jsp?ret=${encodeURIComponent((location.href))}`
                            }

                        }
                    }else {
                        resolve(res.login);
                    }
                },
                fail: () => {
                    resolve(false);
                }
            });
        })
    });
};

const addParams = (url, obj) => {
    const params = [];

    url += url.indexOf('?') === -1 ? '?' : '&';
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
            params.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
        }
    }
    if (params.length) {
        url += params.join('&');
    }
    return url;
};


let supportsPassiveOption = false;
try {
    let opts = Object.defineProperty({}, 'passive', {
        get: function () {
            supportsPassiveOption = true;
        }
    });
    window.addEventListener('test', null, opts);
} catch (e) { }


function appendStyle (cssHtml) {
    let cssElement = document.createElement('style');
    cssElement.innerHTML = cssHtml;
    document.head.appendChild(cssElement);
}
function getURLParam (name) {
    //获取url中的参数
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var rslt = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (rslt != null) {
        return decodeURI(rslt[2]);
    } else {
        return ''; //返回参数值
    }
}

function commonJump(jumpInfo = {}){
    const {appUrl, touchUrl} = jumpInfo;
    if(!appUrl && !touchUrl) return;
    const url = hysdk.sniff.qunar ? (appUrl || touchUrl) : touchUrl;
    smartJump(touchUrl, url.match(/qunar/) ? {type: 'navibar-none'} : {})
}

const setShareInfo = (config) => {
    hysdk.ready(() => {
        hysdk.onMenuShare({...config});
        hysdk.onMenuShareTimeline({...config});  // 微信朋友圈
        hysdk.onMenuShareAppMessage({...config}); // 微信朋友
        hysdk.onMenuShareQQ({...config});

        // 若是微信小程序，则注入相关分享信息
        if (env && env.mpName && env.mpName === 'wx') {
            window.wx.miniProgram.postMessage({data: {
                name: 'updateShareInfo',
                ...config,
                link: config.url,
                img_url: config.imgUrl,
                imageUrl: config.imgUrl,
                path: config.watchUrl || `/pages/vacation/webview/index?url=${encodeURIComponent(config.url)}`
            }})
        }
    });
}

// 返回上一页
const goBack = (option = {}) => {
    if (!hysdk.isReady) {
        hysdk.config({});
    }
    if (hysdk.sniff && hysdk.sniff.qunar) {
        hysdk.ready(() => {
            hysdk.closeWebView(option);
        });
    } else if (env && env.mpName === 'swan') {
        loadSDK(env.sdk).then(() => {
            const navigateBack = window.swan.navigateBack || window.swan.webView.navigateBack;
            navigateBack();
            return;
        });
    } else {
        window.history.back();
    }
};


/**
 * @param {给元素添加样式} styles
 */
 const adaptElement = (styles='') => {
    if(!getMpEnv()) return;
    const head = document.querySelector('head');
    const styleEle = document.createElement('style');
    styleEle.type = 'text/css';
    styleEle.appendChild(document.createTextNode(styles));
    head.appendChild(styleEle);
};

export {
    login,
    appendStyle,
    supportsPassiveOption,
    createAction,
    jsonChecker,
    buildListURL,
    getQueryString,
    updateQueryString,
    getCookie,
    getQueryParams,
    smartJump,
    isNotEmpty,
    getOnLineStatus,
    isNotNil,
    iosStatusBar,
    isQunarApp,
    isQunargonglve,
    isOldversion,
    getAppLink,
    getValue,
    prettyNumber,
    getHashParams,
    getUserResident,
    getDistance,
    debounce,
    throttle,
    judgePartVisible,
    checkLogin,
    addParams,
    getURLParam,
    commonJump,
    setShareInfo,
    goBack,
    adaptElement
};
